import { useState } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@ds';
import { ComponentWithClickOutside } from 'src/utils/hooks/useClickOutside';
import UserIcon from 'src/components/UserIcon/UserIcon';
import { ITab } from '../Home.service';
import styles from './MeatballDropdown.module.scss';

interface MeatballDropdownProps {
  items: ITab[];
  onSelectItem: (id: number) => void;
  currentSelectedItemId?: number;
  shouldHighlightMeatball: boolean;
}

const MeatballDropdown = ({
  items,
  onSelectItem,
  currentSelectedItemId,
  shouldHighlightMeatball,
}: MeatballDropdownProps) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [clickedItemId, setClickedItemId] = useState<number | null>(null);

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const closeTheDropdown = () => {
    if (openDropdown) {
      setOpenDropdown(false);
    }
  };

  return (
    <ComponentWithClickOutside onOutsideClick={closeTheDropdown}>
      <div className={styles['meatball']} onClick={toggleDropdown}>
        <div className={styles['meatball__icon-container']}>
          <div
            className={classNames(styles['meatball__icon'], {
              [styles['meatball__icon--normal']]: !shouldHighlightMeatball,
              [styles['meatball__icon--highlighted']]: shouldHighlightMeatball,
            })}
          />
        </div>
        {openDropdown && (
          <div className={styles['meatball__content']}>
            {items.map((item, index) => {
              const { id, name, userIcon, subTypes = [] } = item;
              const isSelected = id === currentSelectedItemId;
              return (
                <div
                  key={id}
                  className={classNames(`meatball-tooltip-item-${index}`, styles['meatball__dropdown-item'], {
                    [styles['meatball__dropdown-item--selected']]: clickedItemId === id || isSelected,
                  })}
                  onClick={() => onSelectItem(id)}
                  onMouseDown={() => setClickedItemId(id)}
                  onMouseUp={() => setClickedItemId(null)}
                >
                  <Tooltip
                    position="left"
                    target={`.meatball-tooltip-item-${index}`}
                    className={classNames(styles['meatball__dropdown-item-tooltip'], {
                      [styles['meatball__dropdown-item-subtypes-tooltip']]: subTypes.length > 0,
                    })}
                    content={
                      <div className={styles['meatball__tooltip-content']}>
                        {subTypes.length > 0 ? (
                          <div className={styles['meatball__tooltip-with-subtypes']}>
                            <p>{name}</p>
                            <div>{`Subtypes: ${subTypes.join(', ')}`}</div>
                          </div>
                        ) : (
                          name
                        )}
                      </div>
                    }
                  />
                  <UserIcon userIcon={userIcon} className={styles['meatball__user-icon']} />
                  <div className={styles['meatball__title']} title={name}>
                    {name}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </ComponentWithClickOutside>
  );
};

export default MeatballDropdown;
